// extracted by mini-css-extract-plugin
module.exports = {"container":"searchMobile__container___QKM9U","icon":"searchMobile__icon___3pU3x","is-active":"searchMobile__is-active___3sDPg","fake":"searchMobile__fake___2mflB"};